import PropTypes from 'prop-types'
import React from 'react'
import { bindActionCreators } from 'redux'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'

import Button from 'components/Button'
import Input from 'components/Form/Input'
import Textarea from 'components/Form/Textarea'
import Modal from 'components/Modal'

import { send } from 'store/actions/feedback'

import classes from './Feedback.scss'

export const fields = [ 'email', 'phone_number', 'message' ]

class FeedbackModal extends React.Component {
  onSubmit = (...args) => {
    let submitResponse = this.props.handleSubmit(...args)
    if (submitResponse) { // returns a promise, hopefully
      submitResponse.then(response => {
        typeof this.props.closeAction === 'function' && this.props.closeAction()
      })
    }
  };

  renderForm = () => {
    return <form onSubmit={this.onSubmit}>
      <fieldset className={classes.fieldset}>
        <Input label='Your Email' type='email' placeholder='email address' {...this.props.fields.email} />
        <Input label='Your Phone Number' placeholder='phone number' {...this.props.fields.phone_number} />
        <Textarea label='Message' placeholder='your message goes here' {...this.props.fields.message} />

        <div className={classes.buttons}>
          <Button options={['green']} submit>Submit</Button>
          <Button options={['red']} callback={this.props.closeAction}>Cancel</Button>
        </div>
      </fieldset>
    </form>
  };

  render () {
    return <Modal
      isOpen={this.props.isOpen}
      contentLabel='Feedback? Questions? Contact us!'
      onRequestClose={this.props.closeAction}
      title='Have any questions or feedback?'
      description='Contact us using the form below.'
    >
      {this.renderForm()}
    </Modal>
  }
}

FeedbackModal.propTypes = {
  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
  successCallback: PropTypes.func,
  errorCallback: PropTypes.func,

  fields: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}

FeedbackModal.defaultProps = {
  isOpen: false
}

const mapActionCreators = {
  onSubmit: send
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => ({
  initialValues: {
    email: state && state.auth && state.auth.user && state.auth.user.email || ''
  }
})

export const form = reduxForm({
  form: 'feedback',
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.email) errors.email = 'Please enter an email.'
    if (!state.message) errors.message = 'Please enter a message.'

    return errors
  }
})(FeedbackModal)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/containers/Modals/Feedback/Feedback.js